import { OcrActionTypes } from '../actions/OcrAction';

const initState = {
    recognizeTextCompleted: true,
    recognizeTextError: null,
    clearRecognizedTextCompleted: true,
    clearRecognizedTextError: null,
    recognizedText: null,
};

const OcrReducer = (state = initState, action) => {
    switch (action.type) {
        case OcrActionTypes.RecognizeText:
            return {
                ...state,
                recognizeTextCompleted: false,
            };
        case OcrActionTypes.RecognizeTextDone:
            if (action.error) {
                return {
                    ...state,
                    recognizeTextCompleted: true,
                    recognizeTextError: action.error,
                };
            } else {
                return {
                    ...state,
                    recognizeTextCompleted: true,
                    recognizeTextError: null,
                    recognizedText: action.text,
                };
            }
        case OcrActionTypes.ClearRecognizedText:
            return {
                ...state,
                clearRecognizedTextCompleted: false,
            };
        case OcrActionTypes.ClearRecognizedTextDone:
            if (action.error) {
                return {
                    ...state,
                    clearRecognizedTextCompleted: true,
                    clearRecognizedTextError: action.error,
                };
            } else {
                return {
                    ...state,
                    clearRecognizedTextCompleted: true,
                    clearRecognizedTextError: null,
                    recognizedText: null,
                };
            }
        default:
            return state;
    }
};

export default OcrReducer;
